import '../DataCollectionGroupPanel.css'

import { Table, tbody, td, tr } from 'react-bootstrap'

import React from 'react'
import { multiply } from '../../../../helpers/NumericTransformationsHelper.js'

export default class SixSectionPanel extends React.Component {
  getRow(key, value) {
    return (
      <tr>
        <td xs={5} md={5} className="parameterKey">
          {key}
        </td>
        <td xs={7} md={7} className="parameterValue">
          {value}
        </td>
      </tr>
    )
  }

  render() {
    return (
      <Table>
        <tbody>
          {this.getRow('Detector Type', this.props.datacollectiongroup.detectorType)}
          {this.getRow('Detector Model', this.props.datacollectiongroup.detectorModel)}
          {this.getRow('Manufacturer', this.props.datacollectiongroup.Manufacturer)}
          {this.getRow(
            'Pixel Size Hor (Vert)',
            multiply(this.props.datacollectiongroup.detectorPixelSizeHorizontal, 1000) +
              '(' +
              multiply(this.props.datacollectiongroup.detectorPixelSizeVertical, 1000) +
              ') μm'
          )}
        </tbody>
      </Table>
    )
  }
}
